import React from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { useNavigationBlock } from "../../../contexts/NavigationBlock.context"

export default function GoBackIcon() {
  const navigate = useNavigate()
  const location = useLocation()
  const hasPreviousState = location.key !== "default"
  const { setAttemptedNavigation, isBlocked } = useNavigationBlock()

  return (
    <>
      <i
        className="pi pi-arrow-left mr-3 text-md text-white bg-primary border-circle"
        style={{
          cursor: "pointer",
          padding: "8.5px",
        }}
        onClick={() => {
          let prev
          if (hasPreviousState) {
            prev = () => navigate(-1)
          } else {
            prev = () => navigate("/", { replace: true })
          }

          if (isBlocked) {
            return setAttemptedNavigation([true, prev])
          }

          prev()
        }}
      ></i>
    </>
  )
}
